import { isValidValue, normalizeEmail } from "utils";


/**
 * Normalize a POC object from raw form input
 * @param {Object} pocItem - Raw POC object from form
 * @returns {Object|null} Cleaned POC object or null if invalid
 */
export const getPOCValue = (pocItem) => {
  let temp = {};
  [
    "first_name",
    "last_name",
    "email",
    "phone_number",
    "prefix",
    "role",
    "type",
  ].forEach((el1) => {
    if (pocItem.hasOwnProperty(el1)) {
      if (el1 === "role") {
        temp["title"] = pocItem[el1];
      } else if (el1 === "email") {
        // Emails go to the API trimmed and in lowercase
        temp[el1] = normalizeEmail(pocItem[el1]);
      } else if (el1 === "phone_number") {
        temp[el1] = `${pocItem["countryCode"]}${pocItem[el1]}`;
      } else {
        temp[el1] = pocItem[el1];
      }
    }
  });

  const values = Object.values(temp);
  if (values.length && !values.filter((e) => e === "" || !isValidValue(e)).length) {
    return temp;
  }
  return null;
};

/**
 * Extract all valid POCs from the form
 * @param {object} form - useAppForm instance containing POC fields
 * @returns {Array} Array of normalized POCs
 */
export const extractPocsFromForm = (form) => {
  const pocs = [];
  const formValue = form.getValues();
  [
    "districtAdmin",
    "principal",
    "onSiteSecurity",
    "onSiteIT",
    "exteralPoliceDepartment",
    "superintendent",
    "headOfSecurity",
    "headOfIt",
    "other",
  ].forEach((el) => {
    if (isValidValue(formValue[el])) {
      if (Array.isArray(formValue[el])) {
        formValue[el].forEach((e) => {
          const temp = getPOCValue(e);
          if (isValidValue(temp)) pocs.push(temp);
        });
      } else {
        const temp = getPOCValue(formValue[el]);
        if (isValidValue(temp)) pocs.push(temp);
      }
    }
  });
  return pocs;
};
